//
// Official Umbraco Forms Models
//
export var FormConditionsAction;
(function (FormConditionsAction) {
    FormConditionsAction[FormConditionsAction["Show"] = 0] = "Show";
    FormConditionsAction[FormConditionsAction["Hide"] = 1] = "Hide";
})(FormConditionsAction || (FormConditionsAction = {}));
export var FormConditionsLogic;
(function (FormConditionsLogic) {
    FormConditionsLogic[FormConditionsLogic["All"] = 0] = "All";
    FormConditionsLogic[FormConditionsLogic["Any"] = 1] = "Any";
})(FormConditionsLogic || (FormConditionsLogic = {}));
export var FormRuleOperation;
(function (FormRuleOperation) {
    FormRuleOperation[FormRuleOperation["Is"] = 0] = "Is";
    FormRuleOperation[FormRuleOperation["IsNot"] = 1] = "IsNot";
    FormRuleOperation[FormRuleOperation["IsGreaterThan"] = 2] = "IsGreaterThan";
    FormRuleOperation[FormRuleOperation["IsLessThan"] = 3] = "IsLessThan";
    FormRuleOperation[FormRuleOperation["Contains"] = 4] = "Contains";
    FormRuleOperation[FormRuleOperation["StartsWith"] = 5] = "StartsWith";
    FormRuleOperation[FormRuleOperation["EndsWith"] = 6] = "EndsWith";
})(FormRuleOperation || (FormRuleOperation = {}));
